import { SelectAsyncInput } from '@core/components/Select';
import municipioApi from 'app/services/api/servicoGeral/municipioApi';
import React from 'react';

const SelectMunicipioV2 = ({ id, name, label, value, touched, error, helperText, onBlur, onChange, disabled, required }) => {
  return (
    <SelectAsyncInput
      id={id}
      name={name}
      label={label}
      value={value}
      onChange={(event, value) => {
        onChange({
          target: {
            id,
            value,
          },
        });
      }}
      touched={touched}
      error={error}
      helperText={helperText}
      onBlur={onBlur}
      getOptionKey={(option) => option?.id}
      getOptionLabel={(option) => option?.nome || ''}
      fetchData={async (query = '', next = 0) => {
        if (typeof query === 'object') {
          query = '';
        }
    
        const uf = localStorage.getItem('UF') ? localStorage.getItem('UF') : null;
        
        const response = await municipioApi.pesquisar({
          size: 100,
          sort: 'nome',
          page: next,
          q: query,
          uf: uf,
        });
    
        const totalItems = response.headers['x-total-count'];
        const data = response?.data || [];
    
        return { data, totalItems };
      }}
      disabled={disabled}
      fetchOnFocus
      required={required}
    />
  );
};

export default SelectMunicipioV2;
